module.exports = __webpack_public_path__ + "static/media/CheshireLeft.fdf2ef5a.png";